module.exports = __webpack_public_path__ + "img/1.d02306b4.jpg";